// extracted by mini-css-extract-plugin
module.exports = {"containerRoot":"styles_containerRoot__7ddyW","containerCloseButton":"styles_containerCloseButton__v0JG_"};